import generalSection from "../_section/section.class";
import problem from "../_section/section-problem.class";
import {userIdentificationUpload, adminIdentificationUpload} from "./upload";
import ApplicationForm from "./ApplicationForm";
import DataForm from "./DataForm";

export class userIdentificationSection extends generalSection {
    // errors on section, upload-steps on uploads
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userIdentificationUpload);
        // Add missing date error

    }
}

export class adminIdentificationSection extends userIdentificationSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminIdentificationUpload);
        this.sortByDateProp('documentDate');
        this.activeUpload = this.activeUploads.find(u => u.allValuesAnswered && u.isVerifiable)
        this.ApplicationForm = ApplicationForm
        this.DataForm = DataForm
        this.setProblems(this.getProblems());
    }

    getProblems() {
        const problems = this.problemsList.singleUploadUserProblems()
        const applicationDOB = this.mortgage[`applicant${this.applicant}`].personal.dateOfBirth
        if (this.dob && this.dob?.format("YYYY-MM-DD") !== applicationDOB) {
            problems.push(
                new problem({
                    type: 'BUNDLE',
                    title: 'DOB Mismatch',
                    message: `The date of birth on the document does not match the application date of birth`,
                    uploadIDs: [this.activeUpload.id]
                }))
        }
        if (this.fullName && this.fullName.trim() !== this.mortgage[`applicant${this.applicant}`].fullName.trim()) {
            problems.push(new problem(
                {
                    type: 'BUNDLE',
                    title: 'Full Name Mismatch',
                    message: `The full name on the document does not match the application full name`,
                    uploadIDs: [this.activeUpload.id]
                }))
        }
        if (!problems.length) {
            if (this.activeUpload && !this.activeUpload?.props.upload.stampedOn) {
                problems.push(new problem({
                    type: 'BUNDLE',
                    title: 'Missing Stamp',
                    message: `The document is not stamped`,
                    uploadIDs: [this.activeUpload.id]
                }));
            }
        }
        return  problems
    }

    get dob() {
        return this?.activeUpload?.values?.dob || null;
    }

    get expiry() {
        return this?.activeUpload?.values?.documentDate || null;
    }

    get fullName() {
        return this?.activeUpload?.values?.fullName || null;

    }

    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags: [
                    {
                        name: 'Expiry',
                        value: this.activeUpload?.values?.documentDate?.format('D MMM YYYY') || 'Not Provided'
                    },
                    {
                        name: 'Date of Birth',
                        value: this.activeUpload?.values?.dob?.format('D MMM YYYY') || 'Not Provided'
,                    },
                    {
                        name: 'Full Name',
                        value: this.activeUpload?.values?.fullName || 'Not Provided'
                    }
                ]
            }
        ]
    }
}